import manual_payment from './manual_payment/index';
import affiliate from './affiliate/index';
import fallback_package from './fallback_package/index';
import business from './business/index';
import onsend from './onsend/index';
import tax from './tax/index';
import invoice_formula from './invoice_formula/index';
import payment_gateways from './payment_gateways/index';
import SiteMenuItem from '@/js/views/Settings/SiteMenuItem.vue';

const routes = [
  ...affiliate.routes,
  ...manual_payment.routes,
  ...fallback_package.routes,
  ...business.routes,
  ...onsend.routes,
  ...tax.routes,
  ...invoice_formula.routes,
  ...payment_gateways.routes,
];

const menu_items = [
  business.menu_item,
  fallback_package.menu_item,
  affiliate.menu_item,
  manual_payment.menu_item,
  payment_gateways.menu_item,
  onsend.menu_item,
  tax.menu_item,
  invoice_formula.menu_item,
  SiteMenuItem,
];

export default {
  routes,
  menu_items,
};
